/**
 * App Light Theme
 */
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
   palette: {
		type: "light",
      primary: {
          main: '#00955f'
      },
      secondary: {
          main: '#0066CC'
      }
	}
	,overrides: {
		MuiTableRow:{
			root: {
                height: 48
            },
            MuiButton: {
                root: { 
                    textTransform: 'none'
                },
            },
		},
	},
});

export default theme;